module.exports = __webpack_public_path__ + "img/map_7.ef80a0a3.png";